import type { AdminUser } from "~~/schemas/admin-user";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useAuthStore = defineStore("auth", () => {
  const token = ref<any>(null);
  const user = ref<AdminUser | null>(null);
  const workspaces = computed(() => user.value?.workspaces || []);
  const currentWorkspace = computed(() => user.value?.currentWorkspace || null);
  const isLoggedIn = computed(() => !!token.value);

  function login(t: any, u: any) {
    token.value = t;
    user.value = u;
    if (localStorage) {
      console.log("login", t);
      localStorage.setItem("token", t);
    }
  }

  function logout() {
    token.value = null;
    user.value = null;
    if (localStorage) {
      localStorage.removeItem("token");
    }
  }

  function updateUser(u: any) {
    user.value = u;
  }

  return {
    token,
    user,
    workspaces,
    currentWorkspace,
    isLoggedIn,
    login,
    logout,
    updateUser,
  };
});
